import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["tatari"],
  iconColor: "#FFD247", // sun
  getIcon(options) {
    return createIcon(
      `
      <rect x="6.5" y="9" width="11" height="2.33333" fill="black" />
      <rect x="8.6665" y="11.834" width="4.33333" height="2.33333" fill="black" />
      <rect x="10.6665" y="14.666" width="2.33333" height="2.33333" fill="black" />
      `,
      "#FFFAED", // sun-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
